
import { Component, Vue } from "vue-property-decorator";
import ServicesNav from "@/components/Main/Services/ServicesNav.vue";
import ServicesBanner from "@/components/Main/Services/ServicesBanner.vue"
// import PublicPromocode from "@/components/Main/Services/PublicPromocode.vue";
import ServiceOS from "@/components/Main/Services/ServiceOS.vue";
import DexPointModal from "@/components/Main/Services/Modals/DexPointModal.vue" 
@Component({
  components: {
    ServicesNav,
    ServicesBanner,
    ServiceOS,
    // PublicPromocode,
    DexPointModal
  },
})
export default class DexPoint extends Vue {
  public isShowModal: boolean  = false;

  // methods
  public handleShowModal() {
    this.isShowModal = true
  }

  public handleCloseDexPointModal() {
    this.isShowModal = false
  }
}
